import { useState, useEffect, useContext } from 'react';
import { useForm } from "react-hook-form";
import { DataContext } from 'providers/data';

import * as Regex from 'utils/validations';
import { checkListPassword } from 'core/dataCheckListPassword';

import { Typography, Box, Collapse } from '@mui/material';

import Modal from 'components/views/Modals';
import Input from 'components/views/form/Input';
import ContentForgot from 'components/views/ContentForgot';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';
import { Tokenforgot, ErrosAccess } from 'components/views/ContentForgot/ComponentsForgot';

import { ContentForm, StepperCustom, StepMui, StepLabelMui } from './styles';

import CircleIcon from '@mui/icons-material/Circle';
import { ReactComponent as IcIturinOk } from 'assets/icons/ic-iturin-ok.svg';
import BackgroundFirstAccess from 'assets/images/background-first-access.png';

const stepArrayRegister = [1, 2, 3, 4];

const FirstAccess = () => {
    const { register, watch } = useForm();
    const { dataValidateDocument, dataUserAccountPassword, dataSendToken, dataValidatePasswordToken, dataCreateLoginApp, handlePostValidateDocument, handlePostObtainUserLogin, handlePostGetContacts, handlePostSendToken, handlePostValidatePasswordToken, handlePostCreateLoginApp, handlePostAuthentication, handleClearAuthentication } = useContext(DataContext);

    const [stepNav, setStepNav] = useState(0);
    const [stepRegister, setStepRegister] = useState(0);
    const [errorTypes, setErrorTypes] = useState<0 | 1 | 2>(0);

    const [enableBtn, setEnableBtn] = useState(false);
    const [btnIsEmail, setBtnIsEmail] = useState(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);
    const [isOpenModalErrorLogin, setIsOpenModalErrorLogin] = useState(false);

    const [isPinCodeValid, setIsPinCodeValid] = useState(true);

    const [token, setToken] = useState("");
    const [emailContact, setEmailContact] = useState("");
    const [phoneContact, setPhoneContact] = useState("");

    const name = watch('name');
    const login = watch('login');
    const identity = watch('identity');
    const boardOrChassis = watch('boardOrChassis');
    const passwordNew = watch('passwordNew');
    const passwordNewConfirm = watch('passwordNewConfirm');

    const handleValidateRequirementsPassword = (index: number) => {

        switch (index) {
            case 0:
                if ((passwordNew?.length > 5) && (passwordNew?.length < 16)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 1:
                if (passwordNew?.match(/[A-Z]/)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 2:
                if (passwordNew?.match(/[a-z]/)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 3:
                if (passwordNew?.match(/[0-9]/)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }

            case 4:
                if (passwordNew?.match(/\W|_/) && !passwordNew?.match(Regex.emoji)) {
                    return 'secondary.main';
                } else {
                    return 'error.light';
                }
        }
    }

    const handlePostAuthenticationState = () => {
        setIsLoadingBtn(true);
        handlePostAuthentication({ usuario: login, password: passwordNew });
    }

    const handlePostValidateDocumentState = () => {
        setIsLoadingBtn(true);
        handlePostValidateDocument({ document: identity });
    }

    const handlePostValidateClientState = () => {
        setIsLoadingBtn(true);
        handlePostObtainUserLogin({
            chassi: boardOrChassis?.length > 8 ? boardOrChassis.replace('_', '') : '',
            document: identity,
            plate: boardOrChassis?.length > 8 ? '' : boardOrChassis,
            zipCode: ''
        }, false);

        handlePostGetContacts(identity);
    }

    const handlePostSendTokenState = (isEmail: boolean) => {
        setBtnIsEmail(isEmail);
        setIsLoadingBtn(true);

        if (dataUserAccountPassword) {
            handlePostSendToken({
                CdPerson: dataUserAccountPassword.cdPerson,
                ContatoClienteEnum: 2,
                PhoneId: isEmail ? 0 : dataUserAccountPassword.cdPersonPhone,
                SendToEmail: isEmail
            });
        }
    }

    const handlePostValidatePasswordTokenState = (e: string) => {
        setIsLoadingBtn(true);

        if (dataUserAccountPassword) {
            handlePostValidatePasswordToken({
                CdPerson: dataUserAccountPassword.cdPerson,
                Token: e,
            });
            setToken(e);
        }
    }

    const handlePostCreateLoginAppState = () => {
        setIsLoadingBtn(true);

        if (dataUserAccountPassword) {
            handlePostCreateLoginApp({
                Alias: name,
                Zipcode: '',
                Plate: boardOrChassis?.length > 8 ? '' : boardOrChassis,
                Chassi: boardOrChassis?.length > 8 ? boardOrChassis : '',
                Document: identity,
                Email: login,
                Password: passwordNew,
                ConfirmPassword: passwordNewConfirm,
                Token: token
            });
        }
    }

    useEffect(() => {
        if (dataValidateDocument) {
            setIsLoadingBtn(false);

            if (dataValidateDocument.userFound && !dataValidateDocument.obtainUserLogin) {
                setStepRegister(1);
                setStepNav(1);
                if (dataValidateDocument.UsuarioCadastrado) {
                    setStepRegister(7);
                    setErrorTypes(0);
                    return;
                }

                if (dataValidateDocument.Frotista) {
                    setStepRegister(7);
                    setErrorTypes(1);
                    return;
                }

                if (!dataValidateDocument.UsuarioEncontrado) {
                    setStepRegister(7);
                    setErrorTypes(2);
                    return;
                }
            } else if (dataValidateDocument.userFound && dataValidateDocument.obtainUserLogin) {
                setStepRegister(3);
                setStepNav(2);
            } else {
                setStepRegister(7);
                setErrorTypes(2);
            }
        }
    }, [dataValidateDocument]);

    useEffect(() => {
        if (dataUserAccountPassword) {
            dataUserAccountPassword.email && setEmailContact(dataUserAccountPassword.email);
            dataUserAccountPassword?.phoneNumber && setPhoneContact(`(${dataUserAccountPassword.phoneDDD}) ${dataUserAccountPassword.phoneNumber.substring(0, 5)}-${dataUserAccountPassword.phoneNumber.substring(5, 9)}`);
        } else if (dataUserAccountPassword === false) {
            setStepRegister(7);
            setErrorTypes(2);
        }
        setIsLoadingBtn(false);
    }, [dataUserAccountPassword]);

    useEffect(() => {
        setIsLoadingBtn(false);

        if (dataSendToken) {
            setStepRegister(4);
        } else if (dataSendToken === false) {
            setIsPinCodeValid(false);
        }
    }, [dataSendToken]);

    useEffect(() => {
        setIsLoadingBtn(false);

        if (dataValidatePasswordToken) {
            setStepRegister(5);
            setStepNav(3);
        } else if (dataValidatePasswordToken === false) {
            setStepRegister(7);
            setErrorTypes(2);
        }
    }, [dataValidatePasswordToken]);

    useEffect(() => {
        setIsLoadingBtn(false);

        if (dataCreateLoginApp === true) {
            setStepRegister(6);
        } else if (typeof dataCreateLoginApp === 'string') {
            setIsOpenModalErrorLogin(true);
        } else if (dataCreateLoginApp === false) {
            setStepRegister(7);
            setErrorTypes(2);
        }
    }, [dataCreateLoginApp]);

    useEffect(() => {
        if (stepRegister === 0) {
            if (Regex.matchesIdentity(identity)) {
                setEnableBtn(false);
            } else {
                setEnableBtn(true);
            }
        }

        if (stepRegister === 1) {
            if (name?.match(/[a-zA-Z]{3}/)) {
                setEnableBtn(false);
            } else {
                setEnableBtn(true);
            }
        }

        if (stepRegister === 2) {
            if (boardOrChassis?.match(Regex.chassisOrBoard)) {
                setEnableBtn(false);
            } else {
                setEnableBtn(true);
            }
        }

        if (stepRegister === 5) {
            if ((passwordNew === passwordNewConfirm) && (passwordNew?.length > 5) && (passwordNew?.length < 16) && passwordNew?.match(/[A-Z]/) && passwordNew?.match(/[a-z]/) && passwordNew?.match(/[0-9]/) && passwordNew?.match(/\W|_/) && login?.match(Regex.email)) {
                if (passwordNew?.match(Regex.emoji)) {
                    setEnableBtn(true);
                } else {
                    setEnableBtn(false);
                }
            } else {
                setEnableBtn(true);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identity, name, boardOrChassis, stepRegister, passwordNew, passwordNewConfirm, login]);

    return (
        <ContentForgot background={BackgroundFirstAccess} titleNav="Meu 1º Acesso">
            {stepRegister < 6 &&
                <Box sx={{
                    width: { xs: '80%', md: 'fit-content' },
                    position: 'absolute',
                    display: 'flex',
                    top: { xs: '7.25rem', md: '1rem' },
                    left: '0',
                    right: '0',
                    margin: '0 auto',
                    backgroundColor: 'white'
                }}>
                    <StepperCustom activeStep={stepNav} alternativeLabel>
                        {stepArrayRegister.map((label) => (
                            <StepMui key={label}>
                                <StepLabelMui />
                            </StepMui>
                        ))}
                    </StepperCustom>
                </Box>
            }

            <Box sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '2rem 0',
                overflow: 'auto'
            }}>
                <Collapse in={stepRegister < 6}>
                    <ContentForm>
                        <Typography fontSize='1.5625rem' fontWeight={700} sx={{ display: { xs: 'none', md: 'flex' } }}>
                            Meu 1º Acesso
                        </Typography>

                        <Box sx={{ width: '100%' }}>
                            <Typography fontSize='.875rem' lineHeight='1rem' fontWeight={400} sx={{
                                maxWidth: '22.81rem',
                                padding: {
                                    xs: stepRegister === 5 ? '3rem 0 2.625rem' : '0 0 2.625rem',
                                    md: '1rem 0 1.875rem'
                                }
                            }}>
                                {stepRegister === 0 &&
                                    <>Vamos começar com um documento válido.<br /> Você pode usar seu <strong>CPF</strong> ou o <strong>CNPJ</strong> da sua empresa.</>
                                }

                                {stepRegister === 1 &&
                                    'Fala pra gente, como você gostaria de ser chamado.'
                                }

                                {stepRegister === 2 &&
                                    <>Agora vamos <strong>identificar o seu carro,</strong> preencha os <br /> dados abaixo.</>
                                }

                                {stepRegister === 3 &&
                                    <>Encontramos seus dados, <strong>escolha</strong> como gostaria de <br /> receber seu token:</>
                                }

                                {stepRegister === 4 &&
                                    <><strong style={{ fontSize: '1.25rem', fontWeight: 400 }}>Quase lá!</strong><br />Insira o código recebido:</>
                                }

                                {stepRegister === 5 &&
                                    <>Crie <strong>seu login e sua senha</strong> para ter acesso <br /> ao mundo Ituran.</>
                                }
                            </Typography>

                            <>
                                <Collapse in={stepRegister === 0} sx={{ width: '100%' }}>
                                    <Input
                                        name='identity'
                                        label='Insira seu CPF ou CNPJ'
                                        placeholder='000.000.000-00'
                                        type='text'
                                        mask
                                        identity
                                        uppercase
                                        textError="Insira um CPF ou CNPJ válido"
                                        register={{ ...register("identity", { pattern: Regex.identity }) }} />
                                </Collapse>

                                <Collapse in={stepRegister === 1} sx={{ width: '100%' }}>
                                    <Input
                                        name='name'
                                        label='Apelido ou Nome'
                                        placeholder='Seu nome'
                                        type='text'
                                        register={{ ...register("name", { required: true }) }} />
                                </Collapse>

                                <Collapse in={stepRegister === 2} sx={{ width: '100%' }}>
                                    <Input
                                        name='boardOrChassis'
                                        label='Placa do veículo ou Chassi:'
                                        placeholder='AAA1111'
                                        type='text'
                                        mask
                                        identity
                                        typeIdentity='plaque'
                                        register={{ ...register("boardOrChassis", { pattern: Regex.chassisOrBoard }) }}
                                        uppercase
                                    />
                                </Collapse>

                                <Collapse in={stepRegister === 3}>
                                    <Box sx={{ textAlign: 'start', display: 'flex', flexDirection: 'column', alignItems: 'center', 'button': { marginTop: '.3rem', height: '2.8175rem' } }}>
                                        {phoneContact &&
                                            <Box sx={{ width: '100%', maxWidth: '20.625rem' }}>
                                                <Typography fontSize='.75rem' fontWeight={400} >
                                                    SMS
                                                </Typography>
                                                <ButtonRectangle name={phoneContact} onClick={() => handlePostSendTokenState(false)} loadingBtn={isLoadingBtn && !btnIsEmail} />
                                            </Box>
                                        }
                                        <Box
                                            sx={{
                                                width: '100%',
                                                maxWidth: '20.625rem',
                                                display: 'flex',
                                                gap: '1.1875rem',
                                                alignItems: 'center',
                                                'div': {
                                                    width: '100%',
                                                    height: '1px',
                                                    background: 'rgba(28, 56, 107, 0.4)',
                                                },
                                                'p': {
                                                    display: 'flex',
                                                    color: '#A4AFC4',
                                                    padding: '1.25rem 0'
                                                }
                                            }}>
                                            <div />
                                            <p>ou</p>
                                            <div />
                                        </Box>
                                        <Box sx={{ width: '100%', maxWidth: '20.625rem' }}>
                                            <Typography fontSize='.75rem' fontWeight={400} >
                                                E-mail
                                            </Typography>
                                            <ButtonOutlined name={emailContact} onClick={() => handlePostSendTokenState(true)} loadingBtn={isLoadingBtn && btnIsEmail} />
                                        </Box>
                                    </Box>
                                </Collapse>

                                <Tokenforgot show={stepRegister === 4} cancelSendToken={() => setStepRegister(3)} isTokenSuccess={isPinCodeValid} handleSendToken={(e) => handlePostValidatePasswordTokenState(e)} />

                                <Collapse in={stepRegister === 5} sx={{ marginTop: '-1rem' }}>
                                    <Input
                                        name='login'
                                        label='Login'
                                        placeholder='exemplo@xpto.com.br'
                                        type='text'
                                        error={login?.match(Regex.email) ? false : true}
                                        register={{ ...register("login", { required: true }) }} />
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            maxWidth: '21rem',
                                            margin: '-.8rem 0 1.1875rem',
                                            'svg': {
                                                width: '.5rem',
                                                height: '.5rem',
                                                margin: '1px .3rem 0 0',
                                                'path': {
                                                    color: login?.match(Regex.email) ? 'secondary.main' : 'error.light'
                                                }
                                            }
                                        }}>
                                        <CircleIcon />
                                        <Typography variant="body2" color='#ABAEAE' textAlign='start' lineHeight='.875rem'>
                                            Seu login deve ser um e-mail.
                                        </Typography>
                                    </Box>

                                    <Input name="passwordNew" label='Nova Senha' placeholder='***********' type='password' error={(passwordNewConfirm && passwordNewConfirm !== passwordNew)} register={{ ...register("passwordNew", { required: true }) }} />
                                    <Input name="passwordNewConfirm" label='Confirmar nova senha' placeholder='***********' type='password' error={(passwordNewConfirm && passwordNewConfirm !== passwordNew)} register={{ ...register("passwordNewConfirm", { required: true }) }} />
                                    {(passwordNewConfirm && passwordNewConfirm !== passwordNew) &&
                                        <Typography sx={{
                                            color: 'red',
                                            fontWeight: '700',
                                            fontSize: '.75rem',
                                            marginTop: { xs: '-20px', md: '-.5rem' },
                                            marginBottom: { xs: '.5rem', md: '.2rem' },
                                            textAlign: 'left',
                                            marginLeft: '.5rem'
                                        }}>
                                            As senhas digitadas são diferentes
                                        </Typography>
                                    }
                                    <ul>
                                        {checkListPassword.map((value, index) => (
                                            <li key={index}>
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        maxWidth: '21rem',
                                                        marginBottom: '1rem',
                                                        'svg': {
                                                            width: '.5rem',
                                                            height: '.5rem',
                                                            margin: '1px .3rem 0 0',
                                                            'path': {
                                                                color: handleValidateRequirementsPassword(index)
                                                            }
                                                        }
                                                    }}>
                                                    <CircleIcon />
                                                    <Typography variant="body2" color='#ABAEAE' textAlign='start' lineHeight='.875rem'>
                                                        {value}
                                                    </Typography>
                                                </Box>
                                            </li>
                                        ))}
                                    </ul>
                                </Collapse>
                            </>

                            <Collapse in={(stepRegister !== 3) && (stepRegister !== 4)}>
                                <Box sx={{ paddingTop: { xs: '1rem', md: '0' } }}>
                                    <ButtonRectangle
                                        name={stepRegister === 2 ? "VALIDAR DADOS" :
                                            stepRegister === 5 ? "SALVAR DADOS" : 'CONTINUAR'}
                                        disabled={enableBtn}
                                        loadingBtn={isLoadingBtn}
                                        onClick={() => stepRegister === 0 ? handlePostValidateDocumentState() :
                                            stepRegister === 1 ? setStepRegister(2) :
                                                stepRegister === 2 ? handlePostValidateClientState() :
                                                    handlePostCreateLoginAppState()}
                                    />
                                </Box>
                            </Collapse>
                        </Box>
                    </ContentForm>
                </Collapse>
                {/* success */}
                <Collapse in={stepRegister === 6}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        'button': {
                            width: '100%',
                            height: '2.5rem',
                            marginTop: '2.25rem',
                            maxWidth: '20.6875rem'
                        }
                    }}>
                        {stepRegister === 6 &&
                            <IcIturinOk class='teste' id='teste' />
                        }
                        <Box sx={{
                            border: '1.5px solid rgba(151, 201, 61, 0.45)',
                            borderRadius: '10px',
                            height: '3.125rem',
                            padding: '.8rem 5.1rem 0',
                            marginTop: '-34px',
                            backgroundColor: 'white'
                        }}>
                            <Typography fontSize='1.5625rem' textAlign='center' fontWeight={700}>
                                Dados salvos!
                            </Typography>
                        </Box>
                        <ButtonRectangle name="ACESSAR" onClick={() => { handleClearAuthentication(); handlePostAuthenticationState(); }} />
                    </Box>
                </Collapse>

                {/* erros */}
                <ErrosAccess show={stepRegister === 7} typeError={errorTypes} />

                <Modal open={isOpenModalErrorLogin}>
                    <Box sx={{ textAlign: 'center', padding: '2rem 0 0', borderRadius: '8px', width: { xs: 'calc(100vw - 2rem)', md: '22rem' } }}>
                        <Typography fontWeight={700} fontSize='2.1875rem'>
                            Atenção!
                        </Typography>

                        <Box bgcolor='primary.main'
                            sx={{
                                padding: '1rem 1rem 2rem',
                                marginTop: '1rem',
                                display: 'grid',
                                borderRadius: '0 0 8px 8px',
                                button: {
                                    width: '10rem',
                                    margin: '0 auto'
                                }
                            }}>
                            <Typography fontWeight={400} sx={{
                                fontSize: {
                                    xs: '.9375rem',
                                    md: '1.25rem'
                                },
                                lineHeight: 1.2,
                                color: 'white',
                                paddingBottom: '1rem'
                            }}>
                                {dataCreateLoginApp}
                            </Typography>

                            <ButtonRectangle name='CONTINUAR' type='button' onClick={() => setIsOpenModalErrorLogin(false)} />
                        </Box>
                    </Box>
                </Modal>
            </Box >
        </ContentForgot >
    );
}

export default FirstAccess;